import axios from "axios";
const API = axios.create({
    baseURL: process.env.MIX_API_URL,
    // params: {
    //     limit: 15
    // },
    defaults: {
        headers: {
            common: { "X-Requested-With": "XMLHttpRequest" },
            "Content-type": "application/json",
            "Access-Control-Allow-Credentials": "true",
            "Accept-Encoding": "gzip, deflate",
            "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT,DELETE",
        },
        withCredentials: true,
    },
});

const AuthAPI = axios.create({
    baseURL: `/`,
    defaults: {
        headers: {
            common: { "X-Requested-With": "XMLHttpRequest" },
            "Content-type": "application/json",
            "Access-Control-Allow-Credentials": "true",
        },
        withCredentials: true,
    },
});

/**
 * Execute multible axios request at once
 * @param requests
 * @returns {Promise<any[]>}
 */
const allRequests = (requests) => {
    return axios.all(requests);
};
export { allRequests, API, AuthAPI };
